import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Composant de protection de route pour les utilisateurs authentifiés
 * Vérifie si l'utilisateur est connecté via Google OAuth
 * Redirige vers /login si non authentifié
 */
const PrivateRoute = ({ children }) => {
  // Récupérer les infos utilisateur depuis localStorage
  const userStr = localStorage.getItem('user');
  const authMode = localStorage.getItem('auth_mode');
  const accessToken = localStorage.getItem('access_token');
  
  // Vérifier si l'utilisateur est authentifié
  // Doit avoir un utilisateur ET être en mode google (pas guest) ET avoir un token
  const isAuthenticated = userStr && authMode === 'google' && accessToken;

  // Si non authentifié, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si authentifié, afficher le contenu
  return children;
};

export default PrivateRoute;
